import {azureLoginURL, changePasswordURl, enjoyBoardURL, loginURL} from "../../../services/api";
import {
    LOGIN_SUCCESS,
    LOGIN_FAIL,
    REFRESH_TOKEN,
    SUBMITTING_FORM,
    LOGOUT,
    AUTH_VERIFICATION_SUCCESS,
    AUTH_VERIFICATION_FAIL,
    CHANGE_PASSWORD_SUCCESS,
    CHANGE_PASSWORD_FAIL, ENJOY_BOARD_TOKEN, ENJOY_BOARD_TOKEN_FAIL,
} from "./actionTypes"
import TokenService from "../../../services/token.service";
import axios from "axios";
import api from "../../../services/instanceapi";
import {checkErrorMessage} from "../../../utils/utils";
import {FETCH_CURRENT_USER} from "../../user/userTypes";

export const azureLogin = (azureToken) => async (dispatch) => {
    dispatch({
        type: SUBMITTING_FORM
    });
    try {
        const userTokens = await axios.post(azureLoginURL(),{} ,{headers: { Authorization: `Bearer ${azureToken}` }})

        TokenService.setUser(
            userTokens.data.token,
            userTokens.data.refreshToken,
        )
        const data = userTokens.data
        dispatch({
            type:FETCH_CURRENT_USER,
            payload:{
                id: parseInt(data.data.userId),
                roles:data.data.roles
            }
        })
        dispatch({
            type: LOGIN_SUCCESS,
            payload: {
                token: data.token,
                refreshToken: data.refreshToken,
                userId: parseInt(data.data.userId),
                message: 'OK'
            }
        })

        return Promise.resolve();
    } catch (e) {
        const message = checkErrorMessage(e)
        dispatch({
            type: LOGIN_FAIL,
            payload: {message: message},
        });
        return Promise.reject();
    }
}
export const login = (userData) => async (dispatch) => {
    dispatch({
        type: SUBMITTING_FORM
    });
    try {
        const userTokens = await axios.post(loginURL(), userData)
        TokenService.setUser(
            userTokens.data.token,
            userTokens.data.refreshToken,
        )

        const data = userTokens.data
        dispatch({
            type:FETCH_CURRENT_USER,
            payload:{
                id: parseInt(data.data.userId),
                roles:data.data.roles
            }
        })
        dispatch({
            type: LOGIN_SUCCESS,
            payload: {
                token: data.token,
                refreshToken: data.refreshToken,
                userId: parseInt(data.data.userId),
                message: 'OK'
            }
        })

        return Promise.resolve();
    } catch (e) {
        const message = checkErrorMessage(e)
        dispatch({
            type: LOGIN_FAIL,
            payload: {message: message},
        });
        return Promise.reject();
    }
}
export const refreshToken = (token, refreshToken) => async (dispatch) => {
    dispatch({
        type: REFRESH_TOKEN,
        payload: {
            token: token,
            refreshToken: refreshToken
        }
    })
}
export const logout = () => async (dispatch) => {
    TokenService.logout()
    api.interceptors.response.clear()
    dispatch({
        type: LOGOUT,
    })
}

export const authVerification = (userData) => async (dispatch) => {
    try {
        const user = await api.post(loginURL(), userData)
        if (user.status === 200) {
            TokenService.setUser(
                user.data.token,
                user.data.refreshToken,
            )

            dispatch({
                type: AUTH_VERIFICATION_SUCCESS,
                payload: {
                    isConfirmedStatus: user.status,
                    token: user.data.token,
                    refreshToken: user.data.refreshToken,
                }
            })
            return Promise.resolve()
        }
        return Promise.reject()
    } catch (e) {
        const status = e.response.status
        if (status !== 200) {
            dispatch({
                type: AUTH_VERIFICATION_FAIL,
                payload: {
                    isConfirmedStatus: status
                },
            });
        }
        return Promise.reject(e)
    }
}

export const changePassword = (user_id, newPassword) => async (dispatch) => {
    try {
        const user = await api.patch(changePasswordURl(user_id), newPassword)
        if (user.status === 200) {
            dispatch({
                type: CHANGE_PASSWORD_SUCCESS,
                payload: {
                    changedPasswordStatus: user.status
                }
            })
            return Promise.resolve()
        }
        return Promise.reject()
    } catch (e) {
        const status = e.response.status
        if (status !== 200) {
            dispatch({
                type: CHANGE_PASSWORD_FAIL,
                payload: {
                    changedPasswordStatus: status
                },
            });
        }
        return Promise.reject(e)
    }
}

export const getEnjoyBoardToken = () => async (dispatch) => {
    try {
        const data = await api.get(enjoyBoardURL())
        const token = data.data.access_token
        dispatch({
            type: ENJOY_BOARD_TOKEN,
            payload: {
                enjoyBoardToken: token,
                status: 200,
                message: "OK"
            }
        });
    } catch (e) {
        const status = e.response.status
        if (status !== 200) {
            dispatch({
                type: ENJOY_BOARD_TOKEN_FAIL,
                enjoyBoardToken:400
            });
        }
    }
}